import { Button, Divider, InputNumber, Modal, notification } from "antd";
import React, { useState } from "react";
import { Preloader, Rings } from "react-preloader-icon";
import { useHistory, useLocation } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import NavigationBar from "../../components/NavigationBar/NavigationBar";
import { apiTopup, apiTopupRedirect } from "../../services/apis/wallets";

import "antd/dist/antd.css";
import "./Wallets.css";

const Wallets = () => {
  const history = useHistory();
  const location = useLocation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isQrcodeVisible, setIsQrcodeVisible] = useState(false);
  const [title, setTitle] = useState("");
  const [totalTopup, setTotalTopup] = useState(undefined);
  const [txtChannel, setTxtChannel] = useState(undefined);
  const [qrPay, setQrPay] = useState("/assets/artapp/capture.png");
  const [loading, setLoading] = useState(false);

  const qr_list = ["promptpay", "wechat", "alipay"];

  const showModal = () => {
    setIsQrcodeVisible(false);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setTitle("");
    setQrPay("/assets/artapp/capture.png");
    setTotalTopup(undefined);
  };

  const renderApp = (type) => {
    switch (type) {
      case "Mobile banking":
        return "แอปพลิเคชันธนาคาร";
      case "Truemoney Wallet":
        return "แอปพลิเคชัน Truemoney ";
      case "Alipay":
        return "แอปพลิเคชัน Alipay ";
      case "Wechat":
        return "แอปพลิเคชัน Wechat ";
      default:
        return "แอปพลิเคชันธนาคาร";
    }
  };

  const genQrTopup = async (value) => {
    setLoading(true);
    setIsQrcodeVisible(true);

    if (
      (totalTopup < 20 || totalTopup === null) &&
      (value < 20 || value === null)
    ) {
      openNotification("topRight", "เติมเงินขั้นต่ำ 20 บาท");
      setLoading(false);
    } else {
      if (totalTopup) {
        value = totalTopup;
      }
      let datagen = {
        channel: txtChannel,
        amount: value * 100,
        ref1: "",
        ref2: "rondori",
        ref3: "",
      };
      let qrTop = await apiTopup(datagen);
      if (qrTop.status) {
        setLoading(false);
        if (qrTop.result.qrcode) {
          console.log("Fff", qrTop.result);
          setQrPay(qrTop.result.qrcode);
        } else {
          setQrPay("/assets/artapp/capture.png");
        }
      } else {
        openNotification("topRight", "กรุณาลองใหม่อีกครั้ง");
        setLoading(false);
      }
      console.log(datagen);
    }
  };

  const genRedirectTopup = async (value) => {
    setLoading(true);
    setIsQrcodeVisible(true);

    if (
      (totalTopup < 20 || totalTopup === null) &&
      (value < 20 || value === null)
    ) {
      openNotification("topRight", "เติมเงินขั้นต่ำ 20 บาท");
      setLoading(false);
    } else {
      if (totalTopup) {
        value = totalTopup;
      }
      let datagen = {
        channel: txtChannel,
        amount: value * 100,
        ref1: "",
        ref2: "rondori",
        ref3: "",
      };
      let redirectTop = await apiTopupRedirect(datagen);
      if (redirectTop.status) {
        setLoading(false);
        if (redirectTop.result.redirect_url !== "") {
          // window.location.replace(redirectTop.result.redirect_url);
          window.location.href = redirectTop.result.redirect_url;
        } else {
          setQrPay("/assets/artapp/capture.png");
        }
      } else {
        openNotification("topRight", "กรุณาลองใหม่อีกครั้ง");
        setLoading(false);
      }
      console.log(datagen);
    }
  };

  const openNotification = (placement, text) => {
    notification.warning({
      message: `Notification`,
      description: text,
      placement,
    });
  };

  return (
    <div className="App">
      <Navbar />
      <div className="bx-topup">
        <h3 className="title-topup">ช่องทางการเติมเงิน</h3>
        <div className="list-channel">
          <div
            className="bx-channel"
            onClick={(e) => {
              e.preventDefault();
              showModal();
              setTitle("Mobile banking");
              setTxtChannel("promptpay");
            }}
          >
            <div className="op-pay">
              <div className="cov-img">
                <img
                  alt=""
                  className="img-channel"
                  src="/assets/payment/promptpay.jpg"
                />
              </div>
              <div className="txt-channel">
                <p className="txt-bd">PromptPay QR code</p>
                <p className="txt-description">ค่าธรรมเนียม 0 บาท</p>
              </div>
            </div>
          </div>
          <div
            className="bx-channel"
            onClick={(e) => {
              e.preventDefault();
              showModal();
              setTitle("Truemoney Wallet");
              setTxtChannel("promptpay");
            }}
          >
            <div className="op-pay">
              <div className="cov-img">
                <img
                  alt=""
                  className="img-channel"
                  src="/assets/payment/truemoney.jpg"
                />
              </div>
              <div className="txt-channel">
                <p className="txt-bd">TrueMoney Wallet</p>
                <p className="txt-description">ค่าธรรมเนียม 0 บาท</p>
              </div>
            </div>
          </div>

          <div
            className="bx-channel"
            onClick={(e) => {
              e.preventDefault();
              showModal();
              setTitle("KPLUS (T)");
              setTxtChannel("kplus");
            }}
          >
            <div className="op-pay">
              <div className="cov-img">
                <img
                  alt=""
                  className="img-channel"
                  src="/assets/payment/kplus.jpg"
                />
              </div>
              <div className="txt-channel">
                <p className="txt-bd">KPLUS</p>
                <p className="txt-description">
                  ค่าธรรมเนียม 10 บาท เติมมากกว่า 300 ฟรีค่าธรรมเนียม
                </p>
              </div>
            </div>
          </div>

          <div
            className="bx-channel"
            onClick={(e) => {
              e.preventDefault();
              showModal();
              setTitle("SCB EASY App");
              setTxtChannel("scb_easy");
            }}
          >
            <div className="op-pay">
              <div className="cov-img">
                <img
                  alt=""
                  className="img-channel"
                  src="/assets/payment/scb_easy.jpg"
                />
              </div>
              <div className="txt-channel">
                <p className="txt-bd">SCB EASY App</p>
                <p className="txt-description">
                  ค่าธรรมเนียม 10 บาท เติมมากกว่า 300 ฟรีค่าธรรมเนียม
                </p>
              </div>
            </div>
          </div>

          <div
            className="bx-channel"
            onClick={(e) => {
              e.preventDefault();
              showModal();
              setTitle("KMA Krungsri Mobile App");
              setTxtChannel("baybank_deeplink");
            }}
          >
            <div className="op-pay">
              <div className="cov-img">
                <img
                  alt=""
                  className="img-channel"
                  src="/assets/payment/kma.jpg"
                />
              </div>
              <div className="txt-channel">
                <p className="txt-bd">KMA Krungsri App</p>
                <p className="txt-description">
                  ค่าธรรมเนียม 10 บาท เติมมากกว่า 300 ฟรีค่าธรรมเนียม
                </p>
              </div>
            </div>
          </div>

          <div
            className="bx-channel"
            onClick={(e) => {
              e.preventDefault();
              showModal();
              setTitle("Bualuang mBanking");
              setTxtChannel("bbl_deeplink");
            }}
          >
            <div className="op-pay">
              <div className="cov-img">
                <img
                  alt=""
                  className="img-channel"
                  src="/assets/payment/bualuangm.jpg"
                />
              </div>
              <div className="txt-channel">
                <p className="txt-bd">Bualuang App</p>
                <p className="txt-description">
                  ค่าธรรมเนียม 10 บาท เติมมากกว่า 300 ฟรีค่าธรรมเนียม
                </p>
              </div>
            </div>
          </div>

          <div
            className="bx-channel"
            onClick={(e) => {
              e.preventDefault();
              showModal();
              setTitle("Alipay");
              setTxtChannel("alipay");
            }}
          >
            <div className="op-pay">
              <div className="cov-img">
                <img
                  alt=""
                  className="img-channel"
                  src="/assets/payment/alipay.jpg"
                />
              </div>
              <div className="txt-channel">
                <p className="txt-bd">Alipay Wallet</p>
                <p className="txt-description">ค่าธรรมเนียม 0 บาท</p>
              </div>
            </div>
          </div>
          <div
            className="bx-channel"
            onClick={(e) => {
              e.preventDefault();
              showModal();
              setTitle("Wechat");
              setTxtChannel("wechat");
            }}
          >
            <div className="op-pay">
              <div className="cov-img">
                <img
                  alt=""
                  className="img-channel"
                  src="/assets/payment/wechat.jpg"
                />
              </div>
              <div className="txt-channel">
                <p className="txt-bd">Wechat Wallet</p>
                <p className="txt-description">ค่าธรรมเนียม 0 บาท</p>
              </div>
            </div>
          </div>
          <div className="cov-link">
            <p
              onClick={() => {
                history.push("/payment_policy");
              }}
              className="text-term"
            >
              Payment Policy
            </p>
          </div>
        </div>
      </div>

      <Modal
        className="modal-wallet"
        title={title}
        footer={false}
        visible={isModalVisible}
        onCancel={handleCancel}
      >
        {isQrcodeVisible ? (
          <div className="bx-qrcode">
            <div className="bx-img">
              {loading ? (
                <div className="bx-loading">
                  <Preloader
                    use={Rings}
                    size={80}
                    strokeWidth={6}
                    strokeColor="#6dc9c2"
                    duration={2000}
                  />
                </div>
              ) : (
                <img alt="" size={150} className="img-qr" src={qrPay} />
              )}
            </div>
            <div className="bx-download">
              <a
                className="a-download"
                href={qrPay}
                download="output.png"
                type="button"
              >
                Download
              </a>
            </div>
            <p className="note">
              บันทึก/แคปหน้าจอ รูป QR <br />
              และเปิด{renderApp(title)}เพื่อเติมเงิน
            </p>
          </div>
        ) : (
          <div>
            <div className="bx-fill-num">
              <InputNumber
                className="input-topup"
                placeholder="กรอกจำนวนเงิน"
                value={totalTopup}
                min="1"
                step="1"
                onChange={(e) => {
                  let total = Math.floor(e);
                  setTotalTopup(total);
                }}
              />
              <Button
                className="btn-gen-qr"
                onClick={() => {
                  console.log(txtChannel);
                  if (qr_list.includes(txtChannel)) {
                    genQrTopup();
                  } else {
                    genRedirectTopup();
                  }
                }}
              >
                เติมเงิน
              </Button>
            </div>
            <div className="cov-divider">
              <Divider className="txt-devider"> หรือ </Divider>
            </div>
            <div className="bx-fill-num">
              <Button
                className="btn-pre-qr"
                onClick={() => {
                  if (qr_list.includes(txtChannel)) {
                    genQrTopup(100);
                  } else {
                    genRedirectTopup(100);
                  }
                }}
              >
                + 100 บาท
              </Button>
              <Button
                className="btn-pre-qr"
                onClick={() => {
                  if (qr_list.includes(txtChannel)) {
                    genQrTopup(300);
                  } else {
                    genRedirectTopup(300);
                  }
                }}
              >
                + 300 บาท
              </Button>
              <Button
                className="btn-pre-qr"
                onClick={() => {
                  if (qr_list.includes(txtChannel)) {
                    genQrTopup(500);
                  } else {
                    genRedirectTopup(500);
                  }
                }}
              >
                + 500 บาท
              </Button>
            </div>
          </div>
        )}
      </Modal>
      <NavigationBar />
    </div>
  );
};

export default Wallets;
